import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireContact} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class ContactService implements CrudService<UmpireContact> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireContact>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireContact>> {
    return this.http
      .post(`/contacts`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/contacts/${id}`);
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireContact>> {
    return this.http
      .get(`/contacts/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireContact>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireContact>> {
    return this.http
      .patch(`/contacts/${body?.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireContact[]>> {
    return this.http
      .get(`/contacts`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
